module.exports = __webpack_public_path__ + "static/img/9.0d663b8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/qingka1/9.jpg
// module id = 7ZZH
// module chunks = 16